import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import * as revealActions from '../../../actions/revealActions';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class CustomConfirmModal extends React.Component {
  static propTypes = {
    revealActions: PropTypes.any,
    classroomActions: PropTypes.any,
    customMessage: PropTypes.string,
    onSubmit: PropTypes.func
  };

  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.submit = this.submit.bind(this);
  }

  closeModal = () => {
    this.props.revealActions.setCustomConfirmModalOpened(false);
  };

  submit = () => {
    const {
      customConfirmModalObject: { onSubmit }
    } = this.props;
    let res = onSubmit();
    if (res && res.then) {
      res.then(() => {
        this.closeModal();
      });
    } else {
      this.closeModal();
    }
  };

  render() {
    const {
      customConfirmModalObject: { customMessage, opened }
    } = this.props;

    return (
      <Modal
        id="customConfirmModal"
        title={I18n.t('common.uSure')}
        active={opened}
        onClickOutside={this.closeModal}
        children={<Paragraph className="text-grey-700">{customMessage}</Paragraph>}
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')} />
            <Button onClick={this.submit} primary label={I18n.t('common.ok')} />
          </>
        }
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    customConfirmModalObject: state.reveal.customConfirmModalObject
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomConfirmModal);
